/*
  Rating row → owner reviews. The stars in the buy area link to the "What owners say"
  accordion (sections/main-product.liquid, `rating` block). A plain anchor only scrolls;
  this opens the accordion first so the reviews are visible on arrival, and records the
  tap as an Umami `rating_click` event. Two replays in the 2026-09-29 Umami review tapped
  the stars expecting exactly this.

  The warranty note's "Details" link (`warranty_note` block, 2026-10-02) opens the
  guarantee accordion the same way; its event name comes from `data-accordion-event`.
*/
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a.rating-link[href^="#"], a.warranty-note__link[href^="#"]') : null;
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return; // no accordion on this page: let the browser handle the hash
      event.preventDefault();
      var details = target.tagName === 'DETAILS' ? target : target.closest('details');
      if (details && !details.open) details.open = true;
      target.style.scrollMarginTop = '8rem'; // clear the sticky header
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var summary = details ? details.querySelector('summary') : null;
      if (summary && typeof summary.focus === 'function') summary.focus({ preventScroll: true });
      try {
        var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
        if (window.umami && typeof window.umami.track === 'function') {
          window.umami.track(link.getAttribute('data-accordion-event') || 'rating_click', {
            product: match ? decodeURIComponent(match[1]) : undefined,
          });
        }
      } catch (e) {
        /* analytics must never break the page */
      }
    },
    true
  );
})();
